import { ButtonStyleProps, useButtonStyles } from '@modernhealth/vital-components';
import React, { HTMLProps } from 'react';

type ExternalLinkButtonProps = Omit<HTMLProps<HTMLAnchorElement>, keyof ButtonStyleProps> &
    ButtonStyleProps;

export const ExternalLinkButton = React.forwardRef<HTMLAnchorElement, ExternalLinkButtonProps>(
    (props, ref) => {
        const {
            href,
            children,
            target = '_blank',
            rel = 'noreferrer noopener',
            className,
            variant,
            size = 'medium',
            rounded,
            fluid,
            disabled,
            icon,
            iconAlign,
            ...htmlProps
        } = props;

        const buttonStyles = useButtonStyles({
            className,
            variant,
            size,
            rounded,
            fluid,
            disabled,
            icon,
            iconAlign,
        });

        return (
            <a
                ref={ref}
                href={href}
                className={buttonStyles}
                target={target}
                rel={rel}
                {...htmlProps}
            >
                {children}
            </a>
        );
    },
);
